var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatmanLogoThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 17,
    width: 55,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_1",
    d: "m1,0.75c5.550781,1.217391 8.722656,4.26087 7.136719,8.521739c7.929688,-1.826087 16.652344,0 18.238281,5.478261c1.585938,-5.478261 10.308594,-7.304348 18.238281,-5.478261c-1.585938,-4.26087 1.585938,-7.304348 7.136719,-8.521739l-17.445313,0c-0.792969,3.043478 -3.171875,3.652174 -5.947266,3.652174l-0.001546,-0.016642a1.982422,1.826087 0 0 0 -0.054207,-0.413724l-0.340731,-2.613112l-0.873503,1.341036a1.982422,1.826087 0 0 0 -0.712435,-0.123644a1.982422,1.826087 0 0 0 -0.712435,0.124831l-0.873503,-1.342223l-0.343823,2.635701a1.982422,1.826087 0 0 0 -0.049561,0.386376l-0.003101,0.021402c-2.775391,0 -5.154297,-0.608696 -5.947266,-3.652174l-17.445313,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatmanLogoThin);
export default __webpack_public_path__ + "static/media/batman-logo-thin.c478a176ea338eae83304bbc8ce530af.svg";
export { ForwardRef as ReactComponent };